import { LinkService } from '../../../../services/ui/link.service';
import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { CacheService } from './../../../../services/sys/cache.service';

import { FieldMap } from './../../../interfaces/fieldMap.interface'
import { StringToStringMap } from './../../../interfaces/string-string-map.interface'

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'cmn-footer',
    templateUrl: 'cmn-footer.component.html',
    styleUrls: ['cmn-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CmnFooterComponent implements OnInit {
    fieldLabels: StringToStringMap<string> = {};
    showEnglish: boolean = true;
    footerPreAuth: boolean = false;

    constructor(private cacheService: CacheService,
                private linkService: LinkService) {}

    ngOnInit() {
        this.setUpText();
    };

    setUpText() {
        this.fieldLabels = {};

        this.showEnglish = true;
    }

}
